import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-12 border-t border-brand-border bg-brand-primary text-white">
      <div className="mx-auto grid max-w-6xl gap-8 px-6 py-10 md:grid-cols-3 md:px-10">
        <div>
          <h3 className="font-heading text-3xl">Holiday Motel</h3>
          <p className="mt-3 text-sm text-[#dce5ea]">Comfortable stays in Orillia with practical amenities and friendly service.</p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.12em] text-brand-accent">Quick Links</h4>
          <ul className="mt-3 space-y-2 text-sm text-[#dce5ea]">
            <li><a href="#rooms" className="hover:text-white">Rooms</a></li>
            <li><a href="#amenities" className="hover:text-white">Amenities</a></li>
            <li><a href="#policies" className="hover:text-white">Policies</a></li>
            <li><a href="#location" className="hover:text-white">Location</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.12em] text-brand-accent">Contact</h4>
          <p className="mt-3 text-sm text-[#dce5ea]">436 Laclie Street, Orillia, Ontario L3V 4P6</p>
          <a href="tel:+17053251316" className="mt-2 inline-block text-sm text-[#dce5ea] hover:text-white">705-325-1316</a>
        </div>
      </div>
      <div className="border-t border-[#33536a] px-6 py-4 text-center text-sm text-[#dce5ea] md:px-10">
        &copy; {year} Holiday Motel. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
